(ns practitest.frontend.components2.dashboard.charts.stacked-bar
  (:require [practitest.frontend.components2.dashboard.charts.render :as r]
            [practitest.frontend.components2.dashboard.chart :as-alias chart]
            [practitest.frontend.components2.dashboard.charts.protocol :as p]
            [practitest.frontend.components2.dashboard.transforms.stacked-bar :as transforms]
            [practitest.frontend.components2.dashboard.events :as-alias events]
            [re-frame.core :as rf]))

(defmethod p/render! ::chart/stacked-bar [chart _ctx svg-element]
  (let [toggle-evt #(rf/dispatch [::events/toggle-legend-item (:chart/id chart) %])
        spec       {:mark    :bar
                    :height  240
                    :padding {:top 5 :right 20 :bottom 80 :left 35}
                    :tooltip true
                    :data    (:chart/data chart)
                    :encode  {:x     {:field :category
                                      :type  :nominal
                                      :axis  {:label-angle -40
                                              :format      "%y-%m-%d"}
                                      :scale {:domain        (:chart/categories chart)
                                              :padding-inner 0.4
                                              :padding-outer 0.2}}
                              :y     {:field :value
                                      :type  :quantitative
                                      :scale {:domain [0 (:chart/max-value chart)]}
                                      :stacked true}
                              :color {:field  :group
                                      :type   :nominal
                                      :legend {:items (:chart/legend chart)
                                               :offset 60}
                                      :scale  {:domain (:chart/series-labels chart)
                                               :range  (mapv (:chart/colors-palette chart)
                                                             (:chart/series-labels chart))}}}
                    :on-legend-click toggle-evt}]
    (r/render-chart! svg-element spec)))

(defmethod p/transform-data ::chart/stacked-bar [chart]
  (transforms/transform chart))